/**
 * Merken hub brand logo banner — syncs with MuskleCatalogFilters (mc_brand).
 * Multi-select toggle matches sidebar brand checkboxes (OR within brand group).
 */
(() => {
  const ROOT_SEL = '[data-muskle-merken-brand-banner]';

  function brandsFromApi() {
    const api = window.MuskleCatalogFilters;
    if (!api?.getState) return [];
    const set = api.getState().brands;
    return set ? [...set] : [];
  }

  function sync(brands) {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return;
    const selected = new Set(brands || []);
    const none = selected.size === 0;
    const allBtn = root.querySelector('[data-mc-brand-all]');
    if (allBtn) {
      allBtn.classList.toggle('is-active', none);
      allBtn.setAttribute('aria-pressed', none ? 'true' : 'false');
    }
    root.querySelectorAll('[data-mc-brand]').forEach((btn) => {
      const v = btn.getAttribute('data-mc-brand') || '';
      const on = selected.has(v);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function waitApi(cb, tries = 0) {
    if (window.MuskleCatalogFilters?.toggleBrand) {
      cb();
      return;
    }
    if (tries > 100) return;
    window.setTimeout(() => waitApi(cb, tries + 1), 40);
  }

  function onClick(e) {
    const root = e.target.closest(ROOT_SEL);
    if (!root) return;
    const allBtn = e.target.closest('[data-mc-brand-all]');
    const chip = e.target.closest('[data-mc-brand]');
    if (!allBtn && !chip) return;
    e.preventDefault();
    waitApi(() => {
      const api = window.MuskleCatalogFilters;
      if (!api) return;
      if (allBtn) {
        if (typeof api.clearBrands === 'function') api.clearBrands();
        else if (typeof api.setBrands === 'function') api.setBrands([]);
      } else if (chip && typeof api.toggleBrand === 'function') {
        api.toggleBrand(chip.getAttribute('data-mc-brand') || '');
      }
    });
  }

  document.addEventListener('click', onClick);
  document.addEventListener('muskle:catalog-state', (e) => {
    sync(e.detail?.brands || brandsFromApi());
  });
  window.addEventListener('popstate', () => {
    waitApi(() => sync(brandsFromApi()));
  });

  waitApi(() => sync(brandsFromApi()));
})();
